export function formatRetryAfter(retryAfterSeconds: number): string {
    const safeSeconds = Number.isFinite(retryAfterSeconds)
        ? Math.max(1, Math.ceil(retryAfterSeconds))
        : 1;

    if (safeSeconds < 60) {
        return `Try again in ${safeSeconds} second${safeSeconds === 1 ? "" : "s"}.`;
    }

    const minutes = Math.ceil(safeSeconds / 60);
    return `Try again in ${minutes} minute${minutes === 1 ? "" : "s"}.`;
}

export function parseRetryAfterSeconds(
    body: Record<string, unknown>,
    retryAfterHeader: string | null
): number | null {
    const bodyValue = body?.retryAfterSeconds;
    if (typeof bodyValue === "number" && Number.isFinite(bodyValue) && bodyValue > 0) {
        return bodyValue;
    }

    if (typeof bodyValue === "string") {
        const parsed = Number(bodyValue);
        if (Number.isFinite(parsed) && parsed > 0) {
            return parsed;
        }
    }

    if (retryAfterHeader) {
        const headerSeconds = Number(retryAfterHeader);
        if (Number.isFinite(headerSeconds) && headerSeconds > 0) {
            return headerSeconds;
        }
    }

    return null;
}
